import { combineReducers } from 'redux';
import { ArticleAction, UploadFromUrlForm } from '../types';
import {
  uploadMediaFromURLRequest,
  uploadMediaFromURLFail,
  uploadMediaFromURLSuccess, uploadMediaFromURLInitial,
} from '../actions';

const form = (state: UploadFromUrlForm | null = null, action: ArticleAction) => {
  switch (action.type) {
    case uploadMediaFromURLInitial.type:
      return action.payload;
    case uploadMediaFromURLSuccess.type:
      return null;
    default:
      return state;
  }
};

const loading = (state = false, action: ArticleAction) => {
  switch (action.type) {
    case uploadMediaFromURLRequest.type:
      return true;
    case uploadMediaFromURLFail.type:
    case uploadMediaFromURLSuccess.type:
      return false;
    default:
      return state;
  }
};

const error = (state = false, action: ArticleAction) => {
  switch (action.type) {
    case uploadMediaFromURLRequest.type:
    case uploadMediaFromURLSuccess.type:
      return false;
    case uploadMediaFromURLFail.type:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  form,
  loading,
  error,
});
